<template>
    <div class="leftCon">
        <monitor-left-oneself :variables="variables"></monitor-left-oneself>
        <monitor-left-other :variables="variables"></monitor-left-other>
        <monitor-left-statistics :variables="variables"></monitor-left-statistics>
        <monitor-left-map></monitor-left-map>

    </div>
</template>

<script>
import MonitorLeftOneself from './MonitorLeftOneself'
import MonitorLeftOther from './MonitorLeftOther'
import MonitorLeftStatistics from './MonitorLeftStatistics'
import MonitorLeftMap from './MonitorLeftMap'
import xhr from "../../../utils/xhr";

export default {
    name: 'MonitorRight',
    components: {
        MonitorLeftOneself,
        MonitorLeftOther,
        MonitorLeftStatistics,
        MonitorLeftMap,
    },
    data() {
        return {
            variables: {}
        }
    },
    mounted() {
        this.getDashboardVariables()
    },
    methods: {
        getDashboardVariables: function () {
            xhr.getDashboardVariables(({data}) => {
                if (data.status === 'success') {
                    this.variables = data.variables||{}
                }
                console.log('data', data)
            })
        }
    }

}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/monitor/partials/MonitorLeft.vue